import Vue from 'vue';
import Vuetify from 'vuetify';
// import '../../public/css/front.css';
// import '../../node_modules/vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
    theme: {
        dark: true
    }
};
// export default new Vuetify(opts)
export default new Vuetify();
